import { useLang } from '@/i18n';
// import ScrollMagicFn from '@/utils/ScrollMagic';
// import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { TimelineMax, TweenMax } from 'gsap';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';

const B: React.FC = () => {
    const { t } = useLang('stream_ultra_x');
    const { locale = '' } = useRouter();
    const [isM, setIsM] = useState<boolean>(false);
    // const canvasRef = useRef<HTMLCanvasElement>(null);
    const textRef = useRef<HTMLParagraphElement>(null);

    useEffect(() => {
        const initAnimation = () => {
            const isPC = window.innerWidth > 1024;
            const isPad = window.innerWidth <= 1024 && window.innerWidth >= 768;
            const isH5 = window.innerWidth < 768;

            const winH = window.innerHeight;
            // 初始化控制器和场景
            const controller = new ScrollMagic.Controller();
            const scene = new ScrollMagic.Scene({
                triggerElement: '.stream-ultra-x-B',
                triggerHook: 1,
                offset: isH5 ? winH : winH * 1.25,
                duration: isH5 ? 1024 - winH : winH * 0.75,
            });
            // // 创建动画时间线
            const t1 = TweenMax.fromTo('.stream-ultra-x-B .video', 2, { opacity: 1, force3D: true }, { opacity: 0, force3D: true });
            const t2 = TweenMax.fromTo('.stream-ultra-x-B .text-ani', 1.5, { scale: 1, force3D: true }, { scale: 0.67, force3D: true });
            const t3 = TweenMax.fromTo('.stream-ultra-x-B .text1', 1, { color: 'rgba(0, 0, 0, 1)' }, { color: 'rgba(255, 255, 255, 1)' });
            const t4 = TweenMax.fromTo('.stream-ultra-x-B .text2', 0.25, { opacity: 1, force3D: true }, { opacity: 0, force3D: true });
            const t5 = TweenMax.fromTo(
                '.stream-ultra-x-B .text1',
                0.25,
                {
                    fontSize: isPC
                        ? ['fr', 'it'].includes(locale)
                            ? 68
                            : 80
                        : isPad
                        ? ['fr', 'es'].includes(locale)
                            ? 40
                            : 48
                        : ['uk', 'fr', 'it', 'es'].includes(locale)
                        ? 28
                        : 30,

                    maxWidth: '996px',
                },
                {
                    fontSize: isPC
                        ? ['fr'].includes(locale)
                            ? 40
                            : 48
                        : isPad
                        ? ['es'].includes(locale)
                            ? 28
                            : 32
                        : ['uk', 'fr', 'it', 'es'].includes(locale)
                        ? 28
                        : 30,
                    maxWidth: '660px',
                },
            );
            const t6 = TweenMax.fromTo(
                `.stream-ultra-x-B .wrapper${isH5 ? '-h5' : ' .pc-box'}`,
                0.5,
                { opacity: locale === 'de' && isH5 ? 1 : 0, force3D: true },
                { opacity: 1, force3D: true },
            );

            const timeline = new TimelineMax({ paused: true });
            timeline
                .add(t1) //
                .add(t2, '<') //
                .add(t3, '-=0.25')
                .add(t4, '<')
                .add(t5)
                .add(t6, '<');
            // .add(t3, '-=0.5') //
            // .add(t4, '<') //
            // .add(t5) //
            // .add(t6, '-=0.25');
            scene
                .setTween(timeline)
                .on('start', () => timeline.play())
                .on('progress', (e: any) => {
                    if (!textRef.current) return;
                    const _ = e.progress;
                    if (_ < 0.1) {
                        textRef.current.style.textShadow = '1px 1px 0 #FFE394';
                    } else {
                        textRef.current.style.textShadow = `
                            0 0 ${20 * _}px #FF9500, 
                            0 0 ${20 * _}px #FF9500, 
                            0 0 ${20 * _}px #FF9500, 
                            0 0 ${12 * _}px #FF9500, 
                            0 0 ${5 * _}px #FF9500, 
                            0 0 ${3 * _}px #FF9500
                        `;
                    }
                });
            controller.addScene(scene);
            return () => {
                controller.destroy();
            };
        };
        if (typeof window !== 'undefined') {
            setIsM(window.innerWidth < 768);
            const timer = setTimeout(() => {
                initAnimation();
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    return (
        <section
            className={`${css.section} stream-ultra-x-B GtmModuleData-section`}
            id="stream-ultra-x-B"
            data-section-id={'stream-ultra-x-B'}
            data-section-title={t('B_text1')}
        >
            {(locale !== 'de' || !isM) && (
                <div className="outer">
                    <div className="sticky">
                        <div className="video">
                            {/* EcoVideo 在安卓手机Edge/FireFox上不播放 */}
                            {/* src="https://websiteoss.ecoflow.com/upload/video/1753865148304/2.mp4" */}
                            <video
                                poster="https://websiteoss.ecoflow.com/upload/image/1754397531868/2-pc.jpg"
                                preload="metadata"
                                autoPlay
                                muted
                                playsInline
                                loop
                                width="100%"
                                height="100%"
                                aria-label={t('B_text1')}
                                style={{ background: "url('https://websiteoss.ecoflow.com/upload/image/1754397531868/2-pc.jpg') no-repeat center/cover" }}
                            >
                                <source src="https://websiteoss.ecoflow.com/upload/video/1754298197862/sunshine.webm" type="video/webm" />
                                <source src="https://websiteoss.ecoflow.com/upload/video/1753865148304/2.mp4" type="video/mp4" />
                            </video>
                        </div>
                        <div className="text">
                            <div className="text-ani">
                                {/* 隐藏原始文本，用Canvas替代 */}
                                <p className="text1" ref={textRef}>
                                    {t('B_text1')}
                                </p>
                                {/* <canvas ref={canvasRef} className="text1-canvas" /> */}
                                <p className="text2">{t('B_text2')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {!isM && (
                <div className="wrapper" id="learnMore">
                    <div className="pc-box">
                        {/* 保持原有内容不变 */}
                        <div className="l">
                            <div className="l-t box">
                                <img
                                    className="img"
                                    src="https://websiteoss.ecoflow.com/upload/image/1754012297365/2_1.jpg"
                                    loading="lazy"
                                    alt={t('B_item1_title')}
                                />
                                <div className="info">
                                    <p className="title">{t('B_item1_title')}</p>
                                    <p className="desc">{t('B_item1_desc')}</p>
                                </div>
                            </div>
                            <div className="l-m box">
                                <img
                                    className="img"
                                    src="https://websiteoss.ecoflow.com/upload/image/1754012297542/2_2.jpg"
                                    loading="lazy"
                                    alt={t('B_item2_title')}
                                />
                                <div className="info">
                                    <p className="title">{t('B_item2_title')}</p>
                                    <p className="desc">{t('B_item2_desc')}</p>
                                </div>
                            </div>
                            <div className="l-b box">
                                <img
                                    className="img"
                                    src="https://websiteoss.ecoflow.com/upload/image/1754012298193/2_3.jpg"
                                    loading="lazy"
                                    alt={t('B_item3_title')}
                                />
                                <div className="info">
                                    <p className="title">{t('B_item3_title')}</p>
                                    <p className="desc">{t('B_item3_desc')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="c">
                            <div className="c-t box">
                                <img
                                    className="img"
                                    src="https://websiteoss.ecoflow.com/upload/image/1754012297791/2_4.jpg"
                                    loading="lazy"
                                    alt={t('B_item4_title')}
                                />
                                <div className="info">
                                    <p className="title">{t('B_item4_title')}</p>
                                    <p className="desc">
                                        {t.rich('B_item5_title', {
                                            t: (tx: string) => <span className="t">{tx}</span>,
                                            c: (tx: string) => <span className="x">{tx}</span>,
                                        })}
                                    </p>
                                </div>
                            </div>
                            <div className="c-b box">
                                <img
                                    className="img"
                                    loading="lazy"
                                    src={
                                        locale === 'uk'
                                            ? 'https://websiteoss.ecoflow.com/upload/image/1754012053685/2_5_uk.jpg'
                                            : 'https://websiteoss.ecoflow.com/upload/image/1754012298719/2_5.jpg'
                                    }
                                    alt={t.rich('B_item5_desc', {
                                        c: (tx: string) => tx,
                                    })}
                                />
                                <div className="info">
                                    <p className="desc">
                                        {t.rich('B_item5_desc', {
                                            c: (tx: string) => <span className="x">{tx}</span>,
                                        })}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="r">
                            {!['uk', 'it'].includes(locale) && (
                                <div className="r-t box">
                                    <img
                                        loading="lazy"
                                        className="img"
                                        src="https://websiteoss.ecoflow.com/figma-uploads/1756197002264-lw5iyl-compressed-Frame%201612707936.jpg"
                                        alt={t.rich('B_item6_title', {
                                            c: (tx: string) => tx,
                                        })}
                                    />
                                    <div className="info">
                                        <p className="title">
                                            {t.rich('B_item6_title', {
                                                c: (tx: string) => <span className="x">{tx}</span>,
                                            })}
                                        </p>
                                    </div>
                                </div>
                            )}
                            <div className="r-m box">
                                <img
                                    loading="lazy"
                                    className="img"
                                    src={
                                        ['uk', 'it'].includes(locale)
                                            ? 'https://websiteoss.ecoflow.com/upload/image/1754016809841/2_7_uk.jpg'
                                            : 'https://websiteoss.ecoflow.com/upload/image/1754037506258/2_6.jpg'
                                    }
                                    alt={t.rich('B_item7_title', {
                                        m: (tx: string) => tx,
                                        c: (tx: string) => tx,
                                    })}
                                />
                                <div className="info">
                                    <p className="title">
                                        {t.rich('B_item7_title', {
                                            s: (tx: string) => <span className="s">{tx}</span>,
                                            m: (tx: string) => <span className="m">{tx}</span>,
                                            c: (tx: string) => <span className="x">{tx}</span>,
                                        })}
                                    </p>
                                </div>
                            </div>
                            <div className="r-b box">
                                <img
                                    loading="lazy"
                                    className="img"
                                    src={
                                        ['uk', 'it'].includes(locale)
                                            ? 'https://websiteoss.ecoflow.com/upload/image/1754016810240/2_6_uk.jpg'
                                            : 'https://websiteoss.ecoflow.com/upload/image/1754012298373/2_8.jpg'
                                    }
                                    alt={t('B_item8_title')}
                                />
                                <div className="info">
                                    <p className="title">{t('B_item8_title')}</p>
                                    <p className="desc">
                                        {t.rich('B_item8_desc', {
                                            c: (tx: string) => <span className="x">{tx}</span>,
                                        })}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {isM && (
                <div className="wrapper-h5" id="learnMore">
                    {['uk', 'it'].includes(locale) ? (
                        <>
                            <div className="l1 box">
                                <img
                                    className="img"
                                    loading="lazy"
                                    src="https://websiteoss.ecoflow.com/upload/image/1754012633331/2_1_M.jpg"
                                    alt={t('B_item4_title')}
                                />
                                <div className="info">
                                    <p className="title">{t('B_item4_title')}</p>
                                    <p className="desc">
                                        {t.rich('B_item5_title', {
                                            t: (tx: string) => <span className="t">{tx}</span>,
                                            c: (tx: string) => <span className="x">{tx}</span>,
                                        })}
                                    </p>
                                </div>
                            </div>
                            <div className="l2 box">
                                <img
                                    loading="lazy"
                                    className="img"
                                    src={
                                        locale === 'it'
                                            ? 'https://websiteoss.ecoflow.com/upload/image/1754016810660/2_2_uk.jpg'
                                            : locale === 'uk'
                                            ? 'https://websiteoss.ecoflow.com/upload/image/1754016809599/2_2_it.jpg'
                                            : 'https://websiteoss.ecoflow.com/upload/image/1753962641656/2_2_M_uk.jpg'
                                    }
                                    alt={t.rich('B_item5_desc', {
                                        c: (tx: string) => tx,
                                    })}
                                />
                                <div className="info">
                                    <p className="desc">
                                        {t.rich('B_item5_desc', {
                                            c: (tx: string) => <span className="x">{tx}</span>,
                                        })}
                                    </p>
                                </div>
                            </div>
                            <div className="l3">
                                <div className="l3-l box">
                                    <img
                                        loading="lazy"
                                        className="img"
                                        src="https://websiteoss.ecoflow.com/upload/image/1754037505548/2_3_M.jpg"
                                        alt={t.rich('B_item7_title', {
                                            s: (tx: string) => tx,
                                            m: (tx: string) => tx,
                                            c: (tx: string) => tx,
                                        })}
                                    />
                                    <div className="info">
                                        <p className="title">
                                            {t.rich('B_item7_title', {
                                                s: (tx: string) => <span className="s">{tx}</span>,
                                                m: (tx: string) => <span className="m">{tx}</span>,
                                                c: (tx: string) => <span className="x">{tx}</span>,
                                            })}
                                        </p>
                                    </div>
                                </div>
                                <div className="l3-r box">
                                    <img
                                        className="img"
                                        loading="lazy"
                                        src="https://websiteoss.ecoflow.com/upload/image/1754012635364/2_8_M.jpg"
                                        alt={t('B_item8_title')}
                                    />
                                    <div className="info">
                                        <p className="title">{t('B_item8_title')}</p>
                                        <p className="desc">
                                            {t.rich('B_item8_desc', {
                                                c: (tx: string) => <span className="x">{tx}</span>,
                                            })}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="l4 box">
                                <img
                                    className="img"
                                    loading="lazy"
                                    src="https://websiteoss.ecoflow.com/upload/image/1754012635063/2_4_M.jpg"
                                    alt={t('B_item2_title')}
                                />
                                <div className="info">
                                    <p className="title">{t('B_item2_title')}</p>
                                    <p className="desc">{t('B_item2_desc')}</p>
                                </div>
                            </div>
                            <div className="l5">
                                <div className="l5-l box">
                                    <img
                                        className="img"
                                        loading="lazy"
                                        src="https://websiteoss.ecoflow.com/upload/image/1754012633958/2_5_M.jpg"
                                        alt={t('B_item3_title')}
                                    />
                                    <div className="info">
                                        <p className="title">{t('B_item3_title')}</p>
                                        <p className="desc">{t('B_item3_desc')}</p>
                                    </div>
                                </div>
                                <div className="l5-r box">
                                    <img
                                        className="img"
                                        loading="lazy"
                                        src="https://websiteoss.ecoflow.com/upload/image/1754012634844/2_6_M.jpg"
                                        alt={t('B_item1_title')}
                                    />
                                    <div className="info">
                                        <p className="title">{t('B_item1_title')}</p>
                                        <p className="desc">{t('B_item1_desc')}</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="l1 box">
                                <img
                                    className="img"
                                    loading="lazy"
                                    src="https://websiteoss.ecoflow.com/upload/image/1754012633331/2_1_M.jpg"
                                    alt={t('B_item4_title')}
                                />
                                <div className="info">
                                    <p className="title">{t('B_item4_title')}</p>
                                    <p className="desc">
                                        {t.rich('B_item5_title', {
                                            t: (tx: string) => <span className="t">{tx}</span>,
                                            c: (tx: string) => <span className="x">{tx}</span>,
                                        })}
                                    </p>
                                </div>
                            </div>
                            <div className="l2">
                                <div className="l2-l box">
                                    <img
                                        loading="lazy"
                                        className="img"
                                        src="https://websiteoss.ecoflow.com/upload/image/1754012634251/2_2_M.jpg"
                                        alt={t.rich('B_item5_desc', {
                                            c: (tx: string) => tx,
                                        })}
                                    />
                                    <div className="info">
                                        <p className="desc">
                                            {t.rich('B_item5_desc', {
                                                c: (tx: string) => <span className="x">{tx}</span>,
                                            })}
                                        </p>
                                    </div>
                                </div>
                                <div className="l2-r box">
                                    <img
                                        loading="lazy"
                                        className="img"
                                        src="https://websiteoss.ecoflow.com/upload/image/1754037505548/2_3_M.jpg"
                                        alt={t.rich('B_item7_title', {
                                            s: (tx: string) => tx,
                                            m: (tx: string) => tx,
                                            c: (tx: string) => tx,
                                        })}
                                    />
                                    <div className="info">
                                        <p className="title">
                                            {t.rich('B_item7_title', {
                                                s: (tx: string) => <span className="s">{tx}</span>,
                                                m: (tx: string) => <span className="m">{tx}</span>,
                                                c: (tx: string) => <span className="x">{tx}</span>,
                                            })}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="l3 box">
                                <img
                                    className="img"
                                    loading="lazy"
                                    src="https://websiteoss.ecoflow.com/upload/image/1754012635063/2_4_M.jpg"
                                    alt={t('B_item2_title')}
                                />
                                <div className="info">
                                    <p className="title">{t('B_item2_title')}</p>
                                    <p className="desc">{t('B_item2_desc')}</p>
                                </div>
                            </div>
                            <div className="l4">
                                <div className="l4-l box">
                                    <img
                                        className="img"
                                        loading="lazy"
                                        src="https://websiteoss.ecoflow.com/upload/image/1754012633958/2_5_M.jpg"
                                        alt={t('B_item3_title')}
                                    />
                                    <div className="info">
                                        <p className="title">{t('B_item3_title')}</p>
                                        <p className="desc">{t('B_item3_desc')}</p>
                                    </div>
                                </div>
                                <div className="l4-r box">
                                    <img
                                        className="img"
                                        loading="lazy"
                                        src="https://websiteoss.ecoflow.com/upload/image/1754012634844/2_6_M.jpg"
                                        alt={t('B_item1_title')}
                                    />
                                    <div className="info">
                                        <p className="title">{t('B_item1_title')}</p>
                                        <p className="desc">{t('B_item1_desc')}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="l5">
                                <div className="l5-l box">
                                    <img
                                        className="img"
                                        loading="lazy"
                                        src="https://websiteoss.ecoflow.com/upload/image/1754012634605/2_7_M.jpg"
                                        alt={t.rich('B_item6_title', {
                                            c: (tx: string) => tx,
                                        })}
                                    />
                                    <div className="info">
                                        <p className="title">
                                            {t.rich('B_item6_title', {
                                                c: (tx: string) => <span className="x">{tx}</span>,
                                            })}
                                        </p>
                                    </div>
                                </div>
                                <div className="l5-r box">
                                    <img
                                        className="img"
                                        loading="lazy"
                                        src="https://websiteoss.ecoflow.com/upload/image/1754012635364/2_8_M.jpg"
                                        alt={t('B_item8_title')}
                                    />
                                    <div className="info">
                                        <p className="title">{t('B_item8_title')}</p>
                                        <p className="desc">
                                            {t.rich('B_item8_desc', {
                                                c: (tx: string) => <span className="x">{tx}</span>,
                                            })}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            )}
        </section>
    );
};

export default B;
